import type { Example } from '../types';

export const dynamicRangeLimitsExample: Example = {
  id: 'dynamic-range-limits',
  title: 'Dynamic Range Limits',
  categoryId: 'parameters',
  description: '$param references in range bounds; extended safe-range syntax',
  scadCode: `/* Dynamic Range Limits */

// markdown:tip
// **Dynamic Range Limits** — Use \`$param\` inside a range comment to make
// bounds live and reactive. The **extended range** syntax
// \`[hard_min .. [safe_min:step:safe_max] .. hard_max]\` shows a normal
// slider within the safe zone but lets you drag beyond it.

/* [Dimensions] */

// Outer diameter
outer_d = 60; // [10:1:150]

// Inner diameter — max is always outer_d - 2 mm, min tracks wall thickness
inner_d = 40; // [5 .. [10:1:$outer_d] .. $outer_d]

// markdown:warning {inner_d >= outer_d - 2}
// Inner diameter is too close to the outer — the wall will be paper thin!

// Height
height = 35; // [5:1:100]

// Flange height — bounded by overall height
flange_h = 8; // [0 .. [2:0.5:$height] .. $height]

// Flange overhang — bounded by inner/outer gap
flange_overhang = 6; // [0 .. [1:0.5:$outer_d] .. $outer_d]

/* [Detail] */

// Number of bolt holes (0 = none)
bolt_holes = 4; // [0:1:12]

// Bolt hole diameter — sensible max is half the flange overhang
bolt_d = 3; // [1 .. [1.5:0.5:$flange_overhang] .. $flange_overhang] {bolt_holes > 0}

// Color
// color
part_color = [0.55, 0.45, 0.35];

// --- parameters end ---

$fn = 80;
wall = max(0.5, (outer_d - inner_d) / 2);

color(part_color) {
  // Main tube
  difference() {
    cylinder(d=outer_d, h=height);
    translate([0, 0, -0.5])
      cylinder(d=inner_d, h=height + 1);
  }

  // Flange at base
  if (flange_h > 0) {
    difference() {
      cylinder(d=outer_d + flange_overhang * 2, h=flange_h);
      translate([0, 0, -0.5])
        cylinder(d=inner_d, h=flange_h + 1);
      // Bolt holes
      if (bolt_holes > 0)
        for (a = [0 : 360/bolt_holes : 359])
          rotate([0, 0, a])
          translate([outer_d/2 + flange_overhang * 0.55, 0, -0.5])
            cylinder(d=bolt_d, h=flange_h + 1, $fn=16);
    }
  }
}
`,
};
